export default "__VITE_ASSET__CbdIyXU5__"